module.exports = require("@material-ui/core/DialogContent");